var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e2d000;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M52.029.1a52.029,52.029,0,1,0,0,104.058,51.424,51.424,0,0,0,24.677-6.095A14.865,14.865,0,0,0,78.638,100L93.5,114.864a15.163,15.163,0,1,0,21.406-21.406L100.044,78.593a14.866,14.866,0,0,0-2.378-1.932,51.33,51.33,0,0,0,6.541-24.677A52.086,52.086,0,0,0,52.177-.045Zm0,14.865A36.988,36.988,0,0,1,89.192,52.132,37.276,37.276,0,0,1,79.381,77.7l-.446.446A14.865,14.865,0,0,0,77,80.079,37.2,37.2,0,0,1,51.88,89.444a37.163,37.163,0,1,1,0-74.327Z",
    transform: "translate(0 0.045)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnifyingGlass);
export default __webpack_public_path__ + "static/media/icon-magnifying-glass.c830907ba94a820f96f762eb2603198e.svg";
export { ForwardRef as ReactComponent };